import request from './.request'
/**
 * 读取采摘计划数据
 * @param {*} e
 * @returns
 */
export function getHarvestPlan(id,e) {
  return request({
    url: `/harvest-plan/${id}`,
    method: 'get',
    params: e
  })
}



// WEBPACK FOOTER //
// ./src/api/harvest.js